import React from "react";
import FeedsFiltersDropDown from "web/react/components/feeds-filters/feeds-filters-drop-down/feeds-filters-drop-down";
import environment from "web/script/modules/environment";
import { SelectedFilterInfo, StandardFilterProps } from "web/types/feed-filters";
import { PairOfSelectsFilterSection } from "web/types/universal-filters";
// This is only temporary disabled cause we are adding different css
// files depending on if the uj_tree_filter_all_screens flag
// is on or off.
// eslint-disable-next-line css-modules/no-unused-class
import styles1 from "./feeds-filters-pair-of-selects.css";
// eslint-disable-next-line css-modules/no-unused-class
import styles2 from "./feeds-filters-pair-of-selects2.css";

interface PairOfSelectsProps extends StandardFilterProps {
    section: PairOfSelectsFilterSection;
    selectedFilterInfo: SelectedFilterInfo;
}
export function FeedsFiltersPairOfSelects({ section, ...props }: PairOfSelectsProps): JSX.Element {
    let treeStructure = environment.getFeature("uj_tree_filter_all_screens");
    let styles = treeStructure ? styles2 : styles1;

    return (
        <div className={styles.dropDowns}>
            <FeedsFiltersDropDown
                className={styles.dropDown}
                group={section.option_groups[0]}
                {...props}
            />
            <FeedsFiltersDropDown
                className={styles.dropDown}
                group={section.option_groups[1]}
                {...props}
            />
        </div>
    );
}
